// extracted by mini-css-extract-plugin
export default {"container":"Identification_container__dpxNM","idsContainer":"Identification_idsContainer__Yjzwr","idInner":"Identification_idInner__jOt3+"};